// extracted by mini-css-extract-plugin
module.exports = {"creativeDetail":"CreativeDetails-module__creativeDetail___2CxV_","label":"CreativeDetails-module__label___2HyEF"};